<div class="pef-tooltip icon-{{icon}}"
     tabindex="0"
     #tooltip
     [ngClass]="tooltipClasses">

  <mat-icon class="icon"
            aria-hidden="true"
            [ngStyle]="{'width' : iconWidth}"
            [svgIcon]="icon">
  </mat-icon>

  <div class="wrapper">
    <p class="content" #tooltipContent>
      <ng-content></ng-content>
    </p>
  </div>

</div>
